import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ButtonComponent } from '@lucca-front/ng/button';
import { TagComponent } from '@lucca-front/ng/tag';

import { AppStore } from '@src/app-store';
import { PluralizePipe } from '@src/pipes/pluralize.pipe';

@Component({
  imports: [TagComponent, ButtonComponent, PluralizePipe],
  selector: 'app-game',
  templateUrl: './app-game.html',
  styleUrl: './app-game.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppGame {
  readonly store = inject(AppStore);
}
